<data-table (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns" [dataProviderParams]="params" [newHeader]="true"
            [dataProvider]="roleHasPrivilegesService" [searchAll]="true" title="Role Privileges" [headerButtons]="headerButtons">
</data-table>
